/**
 * config/ports.js
 * Port to service/application mapping
 */

// ── Port → Service/Application Map ───────────────────────────────────────────

export const PORT_SERVICE_MAP = {
  20:    { service: "FTP-Data",       app: "File Transfer Protocol (Data)",      risk: "medium" },
  21:    { service: "FTP",            app: "File Transfer Protocol",             risk: "medium" },
  22:    { service: "SSH",            app: "Secure Shell",                       risk: "low"    },
  23:    { service: "Telnet",         app: "Telnet (unencrypted remote access)", risk: "high"   },
  25:    { service: "SMTP",           app: "Simple Mail Transfer Protocol",      risk: "medium" },
  53:    { service: "DNS",            app: "Domain Name System",                 risk: "medium" },
  67:    { service: "DHCP",           app: "Dynamic Host Configuration",         risk: "low"    },
  80:    { service: "HTTP",           app: "HyperText Transfer Protocol",        risk: "medium" },
  110:   { service: "POP3",           app: "Post Office Protocol v3",            risk: "medium" },
  119:   { service: "NNTP",           app: "Network News Transfer Protocol",     risk: "low"    },
  123:   { service: "NTP",            app: "Network Time Protocol",              risk: "low"    },
  135:   { service: "MS-RPC",         app: "Microsoft RPC Endpoint Mapper",      risk: "high"   },
  137:   { service: "NetBIOS-NS",     app: "NetBIOS Name Service",               risk: "high"   },
  138:   { service: "NetBIOS-DGM",    app: "NetBIOS Datagram Service",           risk: "high"   },
  139:   { service: "NetBIOS-SSN",    app: "NetBIOS Session Service",            risk: "high"   },
  143:   { service: "IMAP",           app: "Internet Message Access Protocol",   risk: "medium" },
  161:   { service: "SNMP",           app: "Simple Network Management Protocol", risk: "high"   },
  194:   { service: "IRC",            app: "Internet Relay Chat",                risk: "high"   },
  389:   { service: "LDAP",           app: "Lightweight Directory Access",       risk: "high"   },
  443:   { service: "HTTPS",          app: "HTTP Secure (TLS/SSL)",              risk: "low"    },
  445:   { service: "SMB",            app: "Server Message Block / Windows File Sharing", risk: "critical" },
  465:   { service: "SMTPS",          app: "SMTP over SSL",                      risk: "medium" },
  500:   { service: "IKE",            app: "Internet Key Exchange (IPSec VPN)",  risk: "medium" },
  514:   { service: "Syslog",         app: "System Logging Protocol",            risk: "medium" },
  587:   { service: "SMTP-TLS",       app: "SMTP with STARTTLS",                 risk: "medium" },
  636:   { service: "LDAPS",          app: "LDAP over SSL",                      risk: "medium" },
  993:   { service: "IMAPS",          app: "IMAP over SSL",                      risk: "low"    },
  995:   { service: "POP3S",          app: "POP3 over SSL",                      risk: "low"    },
  1080:  { service: "SOCKS",          app: "SOCKS Proxy",                        risk: "high"   },
  1194:  { service: "OpenVPN",        app: "OpenVPN",                            risk: "medium" },
  1433:  { service: "MSSQL",          app: "Microsoft SQL Server",               risk: "critical"},
  1521:  { service: "Oracle-DB",      app: "Oracle Database",                    risk: "critical"},
  2049:  { service: "NFS",            app: "Network File System",                risk: "high"   },
  2181:  { service: "ZooKeeper",      app: "Apache ZooKeeper",                   risk: "high"   },
  2375:  { service: "Docker",         app: "Docker API (unencrypted)",            risk: "critical"},
  3000:  { service: "Dev-HTTP",       app: "Development HTTP Server",            risk: "medium" },
  3306:  { service: "MySQL",          app: "MySQL Database",                     risk: "critical"},
  3389:  { service: "RDP",            app: "Remote Desktop Protocol",            risk: "critical"},
  3690:  { service: "SVN",            app: "Subversion",                         risk: "medium" },
  4444:  { service: "Metasploit",     app: "Metasploit Framework (default)",     risk: "critical"},
  5000:  { service: "Flask/UPnP",     app: "Flask Dev Server / UPnP",            risk: "medium" },
  5432:  { service: "PostgreSQL",     app: "PostgreSQL Database",                risk: "critical"},
  5900:  { service: "VNC",            app: "Virtual Network Computing",          risk: "critical"},
  5985:  { service: "WinRM-HTTP",     app: "Windows Remote Management (HTTP)",   risk: "critical"},
  5986:  { service: "WinRM-HTTPS",    app: "Windows Remote Management (HTTPS)",  risk: "high"   },
  6379:  { service: "Redis",          app: "Redis In-Memory Database",           risk: "critical"},
  6443:  { service: "Kubernetes",     app: "Kubernetes API Server",              risk: "critical"},
  7001:  { service: "WebLogic",       app: "Oracle WebLogic Server",             risk: "critical"},
  8080:  { service: "HTTP-Alt",       app: "Alternate HTTP / Proxy",             risk: "medium" },
  8443:  { service: "HTTPS-Alt",      app: "Alternate HTTPS",                    risk: "medium" },
  8888:  { service: "Jupyter",        app: "Jupyter Notebook",                   risk: "high"   },
  9000:  { service: "SonarQube",      app: "SonarQube / PHP-FPM",               risk: "medium" },
  9090:  { service: "Prometheus",     app: "Prometheus Metrics Server",          risk: "high"   },
  9200:  { service: "Elasticsearch",  app: "Elasticsearch REST API",             risk: "critical"},
  9300:  { service: "Elasticsearch",  app: "Elasticsearch Transport",            risk: "critical"},
  11211: { service: "Memcached",      app: "Memcached",                          risk: "critical"},
  27017: { service: "MongoDB",        app: "MongoDB Database",                   risk: "critical"},
  31337: { service: "Backdoor",       app: "Elite/Back Orifice Backdoor",        risk: "critical"},
  50070: { service: "Hadoop",         app: "Hadoop HDFS NameNode",              risk: "critical"},
};

export const getPortInfo = (port) => {
  const p = parseInt(port);
  return PORT_SERVICE_MAP[p] || {
    service: p < 1024 ? "Well-Known" : p < 49152 ? "Registered" : "Dynamic/Private",
    app:     `Port ${p}`,
    risk:    p < 1024 ? "medium" : "low",
  };
};
